// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `textarea {
    width: 100%;
    height: 500px;
}
`, "",{"version":3,"sources":["webpack://./src/app/welcome/welcome.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;AACjB","sourcesContent":["textarea {\n    width: 100%;\n    height: 500px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
